<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="checkManges">
      <div slot="toolbar">
        <el-button
            slot="toolbar"
            type="primary"
            size="mini"
            @click="$refs.nonconformingProductManageEdit.open(0)">
          新建
        </el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="物料号">
            <el-input v-model.trim="filter.materialNo" clearable/>
          </vm-search>
          <vm-search label="工序">
            <el-input v-model.trim="filter.process" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="process" width="150" align="center" label="工序"/>
      <el-table-column prop="materialNo" align="center" label="物料号"/>
      <el-table-column prop="status" align="center" label="状态">
        <template slot-scope="scope">
          {{scope.row.status===0 ? "无效" : "有效"}}
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          width="100"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status===0 || editAuth" type="primary" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <nonconforming-product-manage-edit ref="nonconformingProductManageEdit" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import NonconformingProductManageEdit from "./NonconformingProductManageEdit.vue";

  export default {
    components: {NonconformingProductManageEdit, VmTable, VmSearch},
    data() {
      return {
        editAuth: this.$auth(835),
        filter: {
          materialNo: "",
          process: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      edit(row) {
        this.$refs.nonconformingProductManageEdit.open(row);
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
